import { Editor } from '../components';

export default function Root() {
    return (
      <>              
        <Editor />
      </>
    );
  }